"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.inputHeaderDefaultProps = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _text = require("../../text");

var _core = require("@emotion/core");

var _excluded = ["labelId"];

var renderLabel = function renderLabel(_ref) {
  var labelId = _ref.labelId,
      params = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  return (0, _core.jsx)(_text.Label, (0, _extends2.default)({
    id: labelId
  }, params));
};

var inputHeaderDefaultProps = {
  error: false,
  renderLabel: renderLabel,
  required: false,
  tooltipAltText: 'Show tooltip',
  warning: false
};
exports.inputHeaderDefaultProps = inputHeaderDefaultProps;